import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'Components';
import './NumberField.css';

const NumberField = ({
  title,
  required,
  className,
  icon,
  showIcon,
  min,
  max,
  onChange,
  ...rest
}) => {
  const handleChange = (e) => {
    if (min !== undefined && Number(e.target.value) < Number(min)) {
      e.target.value = min;
    }
    if (max !== undefined && Number(e.target.value) > Number(max)) {
      e.target.value = max;
    }
    onChange(e);
  };

  return (
    <div className={`number-field ${className}`}>
      { title &&
        <div className="number-field__label">
          <span>{title}</span>
          { required && <span className="number-field__required">*</span> }
        </div>
      }
      <Input
        {...rest}
        required={required}
        onChange={handleChange}
      />
      {icon && <i className="material-icons">{icon}</i>}
    </div>
  );
};

NumberField.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  showIcon: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
};

NumberField.defaultProps = {
  className: '',
};

export default NumberField;



// WEBPACK FOOTER //
// ./src/components/NumberField/NumberField.jsx